import styled from '@emotion/styled';

const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export default Row;
